import { render, staticRenderFns } from "./ClientAddressForm.vue?vue&type=template&id=baa9af36&"
import script from "./ClientAddressForm.vue?vue&type=script&lang=ts&"
export * from "./ClientAddressForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports